module.exports = __webpack_public_path__ + "static/media/chameleon-consumer-header-horizontal.9d154b0e.svg";